// extracted by mini-css-extract-plugin
module.exports = {"settingsForm":"drawer_settingsForm__1_SNr","dropdownLanguages":"drawer_dropdownLanguages__3BI1B"};